import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, " 当前时间超过预计达成时间未达成合作或完结 ", -1)
const _hoisted_3 = {
  key: 0,
  class: "time-out-flag"
}

import { reactive, computed, ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { DcConfirm, message } from '@dc-platform/dc-components'
import BusinessName from '@/components/BusinessName/index.vue'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import Modal from '@/hooks/modalType'
import { listByParamCodes } from '@/api/common'
import { businessStatusEnum, chanceTimoutFilterEnum, orderTypeEnum } from '@/views/gucangSales/commonEnum/dataConfig'
import type { ParamCodeItem } from '@/typings/common'
import { businessList, businessDelete, businessDetails, businessChangeStatus } from '@/api/gucangSales/chanceManage'
import { BusinessParams, BusinessListItem } from '@/typings/api/chanceManage'
import FavoriteIcon from '@/components/FavoriteIcon/index.vue'
import { cloneDeep } from 'lodash-es'
import { LbuSalesClueParams } from '@/typings/api/clueManage'
import { customerListFormat } from '@/utils'

const __default__ = { name: 'DcCosFbuBusiness' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const router = useRouter()
const route = useRoute()

const statusEnum = businessStatusEnum.map((item) => ({
  name: item.label,
  value: item.value,
  color: item.color
}))
// 时间类型枚举
const timeTypeEnum = [
  { label: '创建时间', value: 0 },
  { label: '跟进时间', value: 1 }
]
const paramCodeData = ref<{
  fbu_tail_warehouse_name: ParamCodeItem[]
  fbu_chance_type: ParamCodeItem[]
  fbu_head_competitors: ParamCodeItem[]
  fbu_warehouse: ParamCodeItem[]
  fbu_head_domestic_warehouse: ParamCodeItem[]
  fbu_head_destination_country_warehouse: ParamCodeItem[]
  fbu_head_replenish_method: ParamCodeItem[]
}>({
  fbu_tail_warehouse_name: [], // 尾程仓库名称
  fbu_chance_type: [], // 商机类型
  fbu_head_competitors: [], // 头程竞争对手
  fbu_warehouse: [], // 尾程竞争对手（目前合作海外仓）
  fbu_head_domestic_warehouse: [], // 国内仓库
  fbu_head_destination_country_warehouse: [], // 目的国仓库
  fbu_head_replenish_method: [] // 运输方式
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_fbu',
    paramCodes: [
      'fbu_tail_warehouse_name',
      'fbu_chance_type',
      'fbu_head_competitors',
      'fbu_warehouse',
      'fbu_head_domestic_warehouse',
      'fbu_head_destination_country_warehouse',
      'fbu_head_replenish_method'
    ]
  }).then((res) => {
    paramCodeData.value = res.data
  })
}
onMounted(() => getByParamCodes())
const tableRef = ref()
const queryForm = reactive<BusinessParams>({ dataType: 'all', timeType: 0 })
const columns = computed(() => [
  { title: '商机名称', dataIndex: 'saleChanceName', fixed: 'left', width: 190 },
  { title: '客户名称', dataIndex: 'customerName', width: 200 },
  { title: '子客户代码', dataIndex: 'arkCode' },
  { title: '客户ID', dataIndex: 'saleChanceRefId', width: 200 },
  { title: '商机ID', dataIndex: 'id', width: 200 },
  { title: '主客户代码', dataIndex: 'customerNumber' },
  { title: '商机类型', dataIndex: 'chanceType' },
  { title: '联系人姓名', dataIndex: 'contactName', cosType: 'mask' },
  { title: '手机号', dataIndex: 'contactMobile', cosType: 'mask' },
  { title: '订单类型', dataIndex: 'orderType' },
  { title: '预计月销售额(万)', dataIndex: 'planSaleAmount' },
  { title: '商机状态', dataIndex: 'status' },
  { title: '尾程竞争对手', dataIndex: 'tailCompetitors' },
  { title: '头程竞争对手', dataIndex: 'headCompetitors' },
  { title: '客户负责人', dataIndex: 'dutyByName' },
  { title: '备注', dataIndex: 'remark' },
  { title: '创建人', dataIndex: 'createByName' },
  { title: '创建时间', dataIndex: 'createTime', width: 190 },
  { title: '达成时间', dataIndex: 'reachTime', width: 190 },
  { title: '完结时间', dataIndex: 'overTime', width: 190 },
  { title: '操作', dataIndex: 'action', width: 180, fixed: 'right' }
])
const handleQueryParams = (queryForm: BusinessParams) => {
  const params = cloneDeep(queryForm)
  const chanceIds = params.id?.toString().split(/[,，\s\n]/).filter((e: string) => e)
  if (chanceIds && chanceIds.length > 1) {
    params.idList = chanceIds
    delete params.id
  }
  return params
}
const getCustomLink = (row:any) => {
  if (row && row.customerStage === 2) {
    return `/fbu/potential/view?cosId=${row.saleChanceRefId}`
  }
  if (row && row.customerStage === 3) {
    return `/fbu/contract/view?cosId=${row.saleChanceRefId}`
  }
  if (row && row.customerStage === 4) {
    return `/fbu/clients/view?cosId=${row.saleChanceRefId}`
  }
  return ''
}
const getList = (queryForm: BusinessParams, callBack: (res: any) => void) => {
  const params = handleQueryParams(queryForm)
  businessList(params).then((res) => {
    callBack(res)
  })
}
const showMask = (record: BusinessListItem, callBack: (res: any) => void) => {
  businessDetails({ id: record.id }).then((res) => {
    callBack(res.data)
  })
}
const handleTabsChange = (val: any) => {
  queryForm.dataType = val
  if (val === 'me' && queryForm.dutyBy) {
    queryForm.dutyBy = undefined
  }
  tableRef.value?.search()
}
// 新增编辑函数
const triggerAddOrEdit = (id?: number) => {
  if (id) {
    router.push({ path: '/fbu/business/edit', query: { id } })
  } else {
    router.push('/fbu/business/add')
  }
}
// 新增编辑函数
const copyChance = (id?: number) => {
  router.push({ path: '/fbu/business/copy', query: { id } })
}
const handleManagerCloseChance = (index: number, row: BusinessListItem) => {
  DcConfirm.warning({
    title: '操作提示！',
    content: '是否确认此操作？',
    cancelText: '取消',
    okText: '继续',
    onOk() {
      if (!row.id) {
        return
      }
      const params = {
        id: row.id.toString(),
        status: 8
      }
      businessChangeStatus(params)
        .then(async () => {
          message.success('商机关闭成功')
          row.status = 8
          tableRef.value?.notifyItem(index, row)
        })
    }
  })
}
const handleDelete = (row: BusinessListItem) => {
  Modal.delete({
    name: row.saleChanceNameByTxt,
    onOk() {
      businessDelete({ id: row.id }).then(() => {
        message.success('删除商机成功')
        tableRef.value?.delFetch()
      })
    }
  })
}
// 跳转写跟进页面
const handleWriteFollowUp = (cosId: string, chanceId: string) => {
  router.push({
    path: '/fbu/followUpRecord/add',
    query: { followRefId: cosId, chanceId, returnPath: route.fullPath }
  })
}
/**
 * 竞争对手序列化
 * @param orderType 订单类型
 * @param arr 对手数组
 */
const competitorFormat = (orderType: number, arr: any) => {
  if (!Array.isArray(arr) || !arr?.length) return '--'
  const hasOrderType = orderTypeEnum.find((e) => e.value === orderType)
  if (!hasOrderType) return arr
  const listEnum = orderType === 1 ? paramCodeData.value.fbu_head_competitors : paramCodeData.value.fbu_warehouse
  const result: string[] = []
  arr.forEach((ele) => {
    const item = listEnum.find((e) => e.id === ele)
    if (item) result.push(item.name as string)
  })
  return result.join('、')
}

return (_ctx: any,_cache: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_CosRangePicker = _resolveComponent("CosRangePicker")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_ExportButton = _resolveComponent("ExportButton")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_dc_status = _resolveComponent("dc-status")!
  const _component_SellerButton = _resolveComponent("SellerButton")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, { "is-breadcrumb": true }, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_tabs, {
            activeKey: queryForm.dataType,
            "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.dataType) = $event)),
            onChange: handleTabsChange
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_tab_pane, {
                key: "all",
                tab: "全部"
              }),
              _createVNode(_component_a_tab_pane, {
                key: "me",
                tab: "我的商机"
              }),
              _createVNode(_component_a_tab_pane, {
                key: "subUser",
                tab: "下属商机"
              })
            ]),
            _: 1
          }, 8, ["activeKey"]),
          _createVNode(_component_cos_table, {
            serial: "",
            columns: columns.value,
            search: queryForm,
            "onUpdate:search": _cache[19] || (_cache[19] = ($event: any) => ((queryForm) = $event)),
            onFetch: getList,
            onMask: showMask,
            ref_key: "tableRef",
            ref: tableRef,
            rowKey: "id",
            tableId: "DcCosFbuBusiness"
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: queryForm }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, {
                    name: "status",
                    label: "商机状态"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: queryForm.statusList,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.statusList) = $event)),
                        options: _unref(businessStatusEnum),
                        placeholder: "请选择商机状态",
                        allowClear: "",
                        mode: "multiple"
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "customerName",
                    label: "客户名称"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.customerName,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.customerName) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 100,
                        allowClear: "",
                        placeholder: "请输入客户名称"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "子客户代码" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.arkCode,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.arkCode) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  (queryForm.dataType !== 'me')
                    ? (_openBlock(), _createBlock(_component_dc_form_item, {
                        key: 0,
                        name: "dutyBy",
                        label: "客户负责人"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_UserSelect, {
                            value: queryForm.dutyBy,
                            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.dutyBy) = $event)),
                            placeholder: "请选择客户负责人",
                            allowClear: ""
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_dc_form_item, {
                    name: "orderType",
                    label: "订单类型"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: queryForm.orderType,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.orderType) = $event)),
                        options: _unref(orderTypeEnum),
                        placeholder: "请选择订单类型",
                        allowClear: ""
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "chanceType",
                    label: "商机类型"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ParamCodesSelect, {
                        value: queryForm.chanceType,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((queryForm.chanceType) = $event)),
                        options: paramCodeData.value.fbu_chance_type,
                        placeholder: "请选择商机类型",
                        allowClear: ""
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "tailWarehouse",
                    label: "尾程仓库名称"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ParamCodesSelect, {
                        value: queryForm.tailWarehouse,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((queryForm.tailWarehouse) = $event)),
                        options: paramCodeData.value.fbu_tail_warehouse_name,
                        placeholder: "请选择尾程仓库名称",
                        allowClear: ""
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "timeOut",
                    label: "是否超时"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: queryForm.changeTimeoutFlag,
                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((queryForm.changeTimeoutFlag) = $event)),
                        options: _unref(chanceTimoutFilterEnum),
                        placeholder: "请选择是否超时",
                        allowClear: ""
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "timeType",
                    label: "时间查询"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_group, { compact: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: queryForm.timeType,
                            "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((queryForm.timeType) = $event)),
                            options: timeTypeEnum,
                            style: {"width":"33%"}
                          }, null, 8, ["value"]),
                          _createVNode(_component_CosRangePicker, {
                            startTime: queryForm.startTime,
                            "onUpdate:startTime": _cache[10] || (_cache[10] = ($event: any) => ((queryForm.startTime) = $event)),
                            endTime: queryForm.endTime,
                            "onUpdate:endTime": _cache[11] || (_cache[11] = ($event: any) => ((queryForm.endTime) = $event)),
                            style: {"width":"67%"}
                          }, null, 8, ["startTime", "endTime"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "tailWarehouse",
                    label: "国内仓库"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ParamCodesSelect, {
                        value: queryForm.headDomesticWarehouse,
                        "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((queryForm.headDomesticWarehouse) = $event)),
                        options: paramCodeData.value.fbu_head_domestic_warehouse,
                        placeholder: "请选择国内仓库",
                        allowClear: ""
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "tailWarehouse",
                    label: "目的国仓库"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ParamCodesSelect, {
                        value: queryForm.headDestinationCountryWarehouse,
                        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((queryForm.headDestinationCountryWarehouse) = $event)),
                        options: paramCodeData.value.fbu_head_destination_country_warehouse,
                        placeholder: "请选择目的国仓库",
                        allowClear: ""
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "tailWarehouse",
                    label: "运输方式"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ParamCodesSelect, {
                        value: queryForm.headTransportMode,
                        "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((queryForm.headTransportMode) = $event)),
                        options: paramCodeData.value.fbu_head_replenish_method,
                        placeholder: "请选择运输方式",
                        allowClear: ""
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "sourceChannelList",
                    label: "来源渠道"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(ParamCodeCascader, {
                        ids: queryForm.sourceChannelList,
                        "onUpdate:ids": _cache[15] || (_cache[15] = ($event: any) => ((queryForm.sourceChannelList) = $event)),
                        type: "search",
                        appId: "cos_fbu",
                        paramCode: "fbu_source_channel",
                        placeholder: "请选择来源渠道",
                        allowClear: ""
                      }, null, 8, ["ids"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "saleChanceRefId",
                    label: "客户ID"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.saleChanceRefId,
                        "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((queryForm.saleChanceRefId) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 500,
                        allowClear: "",
                        placeholder: "请输入客户ID"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "id",
                    label: "商机ID"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.id,
                        "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((queryForm.id) = $event)),
                        maxlength: 500,
                        allowClear: "",
                        placeholder: "请输入商机ID"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                onClick: _cache[18] || (_cache[18] = ($event: any) => (triggerAddOrEdit()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("新增")
                ]),
                _: 1
              })), [
                [_directive_permission, 'fbu_business_add_btn']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_ExportButton, {
                appId: "cos_fbu",
                taskType: "207",
                search: handleQueryParams(queryForm)
              }, {
                default: _withCtx(() => [
                  _createTextVNode("导出")
                ]),
                _: 1
              }, 8, ["search"])), [
                [_directive_permission, 'fbu_business_export_btn']
              ])
            ]),
            bodyCell: _withCtx(({ column, record, text,index }) => [
              (column.dataIndex === 'saleChanceName')
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_a_tooltip, {
                      placement: "topLeft",
                      color: "rgba(19, 32, 67, 0.9)"
                    }, {
                      title: _withCtx(() => [
                        _hoisted_2
                      ]),
                      default: _withCtx(() => [
                        (record.changeTimeoutFlag === true)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_3, "超时"))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_router_link, {
                      to: '/fbu/business/view?id=' + record.id
                    }, {
                      default: _withCtx(() => [
                        text
                          ? (_openBlock(), _createBlock(BusinessName, {
                              key: 0,
                              appId: "cos_fbu",
                              value: record.saleChanceName,
                              "onUpdate:value": ($event: any) => ((record.saleChanceName) = $event),
                              label: record.saleChanceNameByTxt,
                              "onUpdate:label": ($event: any) => ((record.saleChanceNameByTxt) = $event)
                            }, null, 8, ["value", "onUpdate:value", "label", "onUpdate:label"]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode("--")
                            ], 64))
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                : _createCommentVNode("", true),
              (column.dataIndex === 'customerName')
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: getCustomLink(record),
                    class: "ant-table-cell-ellipsis",
                    title: text
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(text || '--'), 1)
                    ]),
                    _: 2
                  }, 1032, ["to", "title"]))
                : _createCommentVNode("", true),
              (column.dataIndex === 'status')
                ? (_openBlock(), _createBlock(_component_dc_status, {
                    key: 2,
                    enums: _unref(statusEnum),
                    value: text
                  }, null, 8, ["enums", "value"]))
                : _createCommentVNode("", true),
              (column.dataIndex === 'orderType')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _createTextVNode(_toDisplayString(_unref(orderTypeEnum)?.find((e) => e.value === text)?.label || text || '--'), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (column.dataIndex === 'chanceType')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                    _createTextVNode(_toDisplayString(paramCodeData.value.fbu_chance_type?.find((e) => e.id === text)?.name || text), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (column.dataIndex === 'headCompetitors' || column.dataIndex === 'tailCompetitors')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                    _createTextVNode(_toDisplayString(competitorFormat(record.orderType, text) || '--'), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (column.dataIndex === 'action')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                    _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                      type: "link",
                      onClick: ($event: any) => (handleWriteFollowUp(record.saleChanceRefId, record.id))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("写跟进")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])), [
                      [_directive_permission, 'fbu_business_write_follow_btn']
                    ]),
                    _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
                      type: "link",
                      workCode: record.dutyBy,
                      disabled: record.status>6,
                      onClick: ($event: any) => (triggerAddOrEdit(record.id))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("编辑")
                      ]),
                      _: 2
                    }, 1032, ["workCode", "disabled", "onClick"])), [
                      [_directive_permission, 'fbu_business_edit_btn']
                    ]),
                    _createVNode(_component_a_button, {
                      type: "link",
                      disabled: record.chanceType != 399,
                      onClick: ($event: any) => (copyChance(record.id))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("复制")
                      ]),
                      _: 2
                    }, 1032, ["disabled", "onClick"]),
                    _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
                      type: "link",
                      disabled: record.status >= 7,
                      onClick: ($event: any) => (handleManagerCloseChance(index,record))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("关闭 ")
                      ]),
                      _: 2
                    }, 1032, ["disabled", "onClick"])), [
                      [_directive_permission, 'fbu_chance_close_btn']
                    ]),
                    _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                      type: "link",
                      onClick: ($event: any) => (handleDelete(record))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("删除")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])), [
                      [_directive_permission, 'fbu_business_del_btn']
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["columns", "search"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})